import { jsx } from "react/jsx-runtime";
const SvgDivider = (props) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 3 36", ...props, children: /* @__PURE__ */ jsx("line", { x1: 1, y1: 0, x2: 1, y2: 36, stroke: "currentColor", strokeWidth: 1.5 }) });
export default SvgDivider;
